<template>
  <header class="header-container" :class="mode === 'easy' && 'header-container-easy'">
    <!-- 轮播 -->
    <swiper
      :options="swiperOption"
    >
      <swiper-slide :style="{backgroundImage: `url(${header_bg1})`}"></swiper-slide>
      <swiper-slide v-if="mode !== 'easy'" :style="{backgroundImage: `url(${header_bg2})`}"></swiper-slide>
    </swiper>
    <!-- logo -->
    <img class="logo-img" :src="logoImg" />
    <!-- 导航 -->
    <nav>
      <a :class="tabIndex === '1' && 'active'" @click="e => chooseTab('1')">首页</a>
      <a :class="tabIndex === '2' && 'active'" @click="e => chooseTab('2')">公司简介</a>
      <a :class="tabIndex === '3' && 'active'" @click="e => chooseTab('3')">团队建设</a>
      <a :class="tabIndex === '4' && 'active'" @click="e => chooseTab('4')">公司历程</a>
    </nav>
    <!-- 标题 -->
    <div class="title" v-if="mode !== 'easy'">集金融之智，友科创之城</div>
  </header>
</template>

<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'

export default {
  name: 'home-header',
  components: { swiper, swiperSlide },
  props: {
    tabIndex: {
      type: String,
      default: '1'
    }
  },
  data () {
    return {
      header_bg1: require('@/assets/images/header_bg1.jpg'),
      header_bg2: require('@/assets/images/header_bg2.jpg'),
      logoImg: require('@/assets/images/logo_white.png'),
      swiperOption: {
        autoplay: {
          delay: 10000,
          disableOnInteraction: false
        },
        loop: true
      }
    }
  },
  computed: {
    // 头部模式
    mode () {
      return this.tabIndex === '1' ? 'normal' : 'easy'
    }
  },
  methods: {
    chooseTab (tab) {
      if (tab !== this.tabIndex) {
        const tabList = ['', 'index', 'introduction', 'team', 'history']
        const path = `/${tabList[+tab]}`
        this.$router.push(path)
      }
    }
  }
}
</script>

<style scoped lang="less">
  .header-container {
    position: relative;
    .swiper {
      width: 100%;
    }
    .swiper-wrapper .swiper-slide {
      position: relative;
      height: 500px;
      background-size: 100%;
      &::after {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        content: '';
        background-color: rgba(0, 0, 0, 0.4);
      }
    }
    .logo-img {
      position: absolute;
      top: 40px;
      left: 10%;
      width: 300px;
      z-index: 99;
    }
    nav {
      position: absolute;
      top: 40px;
      right: 10%;
      z-index: 99;
      display: flex;
      a {
        margin-left: 30px;
        font-size: 20px;
        line-height: 1.5;
        font-weight: bold;
        color: #FFFFFF;
        &.active,
        &:hover {
          color: #a20067;
          border-bottom: 6px solid #a20067;
        }
      }
    }
    .title {
      position: absolute;
      left: 0;
      bottom: 100px;
      width: 100%;
      font-size: 50px;
      font-weight: bold;
      text-align: center;
      color: #FFFFFF;
      z-index: 99;
    }
  }

  .header-container-easy {
    .swiper-wrapper .swiper-slide {
      height: 100px;
      background-position-y: -330px;
    }
  }
</style>